import { encryptObject } from "@/helpers/noncehelper";
import { appendStoreIdToItems } from "@/helpers/storageHelper";
import { addToCartItem, fetchManagementList } from "@/services/products";
import { fetchSafeJson } from "@/utils/apiResponse";
import { Meta } from "@/utils/types/manageList";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchCartProducts = createAsyncThunk(
  "get_cartlist",
  async (payload: {isActive: boolean, isFavourite: boolean, userToken: string, storeId: string }, {rejectWithValue} ) => {
    const {userToken , ...rest} = payload;
    const data = await fetchManagementList(
      encryptObject(payload),
    );
   
    const safeJson = await fetchSafeJson(data)
    if(safeJson?.status != 400){
      const updatedData = await  safeJson.response?.getListData?.map((category: { items: any[]; }) => ({
        ...category,
        items:  appendStoreIdToItems(category?.items, payload.storeId ),
    }));
    safeJson.response.getListData = updatedData
    if(updatedData){
      return safeJson.response;
    }
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details
      );
    }
  }
);

export const addItemToCartList = createAsyncThunk(
  "add_shopping_list_cart",
  async (payload: {
    categoryId?: string;
    meta?: Meta;
    itemId: string | number;
    quantity: number;
    listType: string;
    isFavourite: number;
    isShopped?: number;
    userToken: string;
    storeId?: string;
  }, {rejectWithValue}) => {
    const {userToken, ...rest} = payload;
    const data = await addToCartItem(
      encryptObject(payload)

    );
    
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      if(safeJson?.response?.resultData){
        safeJson.response.resultData.item_id += `_${payload.storeId}`
      }
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details
      );
    }
  }
);